<template>
    <schedule-invoice-body
        class="tile-content tile-content-secondary"
        @add-attempt="addAttempt"
        @delete-attempt="deleteAttempt"
        :attempts="action.attempts">
        <template #attempt="{attempt, index, formatter}">
            <define-schedule-view
                :format-type-drop-down-label="formatter"
                :schedule-instruction="attempt.scheduleInstruction"
                invoice-retry-schedule
                :validate="$v.action.attempts[index].scheduleInstruction"
                @update="data => updateSchedule(index, data)"/>
        </template>
        <template #after-each-attempt>
            <div class="grid-content">
                <div
                    :key="option.value"
                    v-for="option in afterAttemptPolicies"
                    class="grid-item grid-item-full">
                    <v-checkbox
                        :value="option.value"
                        v-model="action.afterAttemptPolicies"
                        :label="option.label"/>
                </div>
            </div>
        </template>
        <template #after-last-attempt>
            <div class="grid-content">
                <div
                    :key="option.value"
                    v-for="option in afterRetryEndPolicies"
                    class="grid-item grid-item-full">
                    <v-checkbox
                        :value="option.value"
                        v-model="action.afterRetryEndPolicies"
                        :label="option.label"/>
                </div>
            </div>
        </template>
        <template #optional-footer>
            <div class="divider divider-tile-content"></div>
            <h3 class="stack-m">Override Existing Retry</h3>
            <p class="stack-m">You may wish to override the existing retry on the invoice.</p>
            <div class="grid-content">
                <div class="grid-item grid-item-half grid-item-half-break">
                    <v-checkbox
                        :value="true"
                        v-model="action.overrideRetryInstruction"
                        label="Override Retry"/>
                </div>
            </div>
        </template>
    </schedule-invoice-body>
</template>

<script>
    import ScheduleInvoiceRetryActionModel from '@/common/models/rules/actions/schedule-invoice-retry-action-model';
    import {
        vIcon, vIconButton, vCheckbox,
    } from '@/components/form';
    import DefineScheduleView from '@/modules/rules-engine/components/actions/schedule-payment/define-schedule-view';
    // import DefinePaymentView from '@/modules/rules-engine/components/actions/schedule-payment/define-payment-view';
    import getScheduleValidation
        from '@/modules/rules-engine/components/actions/schedule-payment/get-schedule-validation';
    // import getPaymentValidation
    //     from '@/modules/rules-engine/components/actions/schedule-payment/get-payment-validation';
    import BaseAction from '@/modules/rules-engine/actions/base-action';
    import ScheduleInvoiceBody from '@/modules/rules-engine/actions/schedule-invoice-retry/schedule-invoice-body';

    export default {
        name: 'schedule-invoice-retry',
        extends: BaseAction,
        components: {
            vIcon,
            vCheckbox,
            vIconButton,
            // DefinePaymentView,
            DefineScheduleView,
            ScheduleInvoiceBody,
        },
        computed: {
            afterAttemptPolicies() {
                return ScheduleInvoiceRetryActionModel.getAfterAttemptPolicies();
            },
            afterRetryEndPolicies() {
                return ScheduleInvoiceRetryActionModel.getAfterRetryEndPolicies();
            },
        },
        validations() {
            const validations = {
                action: {
                    attempts: {},
                },
            };

            validations.action.attempts = this.action.attempts.reduce((memo, attempt, index) => ({
                ...memo,
                [index]: {
                    scheduleInstruction: getScheduleValidation(attempt.scheduleInstruction),
                    // paymentInstruction: getPaymentValidation(attempt.paymentInstruction),
                },
            }), {});
            return validations;
        },
        methods: {
            addAttempt() {
                this.action.addAttempt();
            },
            deleteAttempt(index) {
                this.action.deleteAttempt(index);
            },
            updateSchedule(index, scheduleInstruction) {
                this.action.updateAttempt(index, {scheduleInstruction});
            },
            // updatePayment(index, paymentInstruction) {
            //     this.action.updateAttempt(index, {scheduleInstruction});
            // },
            getValidationAggregate() {
                return {
                    name: 'schedule-invoice-retry',
                    rules: [
                        {
                            name: `The Schedule Invoice Retry fields are invalid.`,
                            delegate: () => {
                                this.$v.$touch();
                                return this.$v.$error;
                            },
                        },
                    ],
                };
            },
        },
    };
</script>
